export default __webpack_public_path__ + "static/media/plus.43dd8298.svg";